export default __webpack_public_path__ + "static/media/dashboard-graph.b1dbbec2.svg";